import { render } from "./ConfigurationInfo.vue?vue&type=template&id=522845e2&scoped=true&ts=true"
import script from "./ConfigurationInfo.vue?vue&type=script&lang=ts"
export * from "./ConfigurationInfo.vue?vue&type=script&lang=ts"

import "./ConfigurationInfo.vue?vue&type=style&index=0&id=522845e2&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522845e2"]])

export default __exports__